<template lang="html">

  <section class="ofertas-home">

    <template>

      <nav class="selector-tipo row-start">
        <a v-if="ofertasPracticasEstudiantes  && isEstudiante" :active="(how == 1) ? 'true' : 'false'" @click="how = 1">
          <span class="pc">PRÁCTICAS ESTUDIANTES ULE</span>
          <span class="mvl">PRÁCTICAS ESTUDIANTES ULE</span>
        </a>

        <a v-if="isTitulado" :active="(how == 2) ? 'true' : 'false'" @click="how = 2">
          <span class="pc">PRÁCTICAS TITULADOS</span>
          <span class="mvl">PRÁCTICAS TITULADOS</span>
        </a>

        <a v-if="isTitulado" :active="(how == 3) ? 'true' : 'false'" @click="how = 3">
          <span class="pc">EMPLEO </span>
          <span class="mvl">EMPLEO </span>
        </a>
      </nav>

      <template v-if="itsLoader">
        <oferta-el--fake :key="'fake'+key" v-for="(oferta, key) in 4"></oferta-el--fake>
      </template>
      
      <template v-if="ofertasPracticasEstudiantes && !itsLoader">
        <div class="ofertas-list" v-if="ofertasPracticasEstudiantes.length > 0" v-show="!itsLoader && how == 1">
          <p class="mt-20">Ofertas de prácticas dirigidas a estudiantes de la Universidad para el desarrollo de sus prácticas curriculares y extracurriculares</p>
          <oferta-el v-for="(oferta, key) in ofertasPracticasEstudiantes.slice(0,5)" :key="`practicas-${key}`" :data="oferta"
            :type="'practicas'"></oferta-el>
          <div class="contenedor-ver-todas" :style="ownstyles.verTodas"></div>
          <arrow-link class="arrow-link" :text="'Ver todas'" :to="$t('enlaces.ofertas_practicas')"></arrow-link>
        </div>
        <div class="ofertas-list" v-else-if="how == 1">
          <p class="mt-20">Actualmente no hay ofertas de prácticas disponibles.</p>
        </div>
      </template>

      <template v-if="ofertasPracticasTitulados && !itsLoader">
        <div class="ofertas-list" v-if="ofertasPracticasTitulados.length > 0" v-show="!itsLoader && how == 2">
           <p class="mt-20">Programas de prácticas dirigidos a titulados universitarios y de formación profesional. Consulta los programas de prácticas activos <router-link to="/programas-practicas-activos">aquí</router-link>.</p>
          <oferta-el v-for="(oferta, key) in ofertasPracticasTitulados.slice(0,5)" :key="`practicas-${key}`" :data="oferta"
            :type="'practicas'"></oferta-el>
          <div class="contenedor-ver-todas" :style="ownstyles.verTodas"></div>
          <arrow-link class="arrow-link" :text="'Ver todas'" :to="$t('enlaces.ofertas_practicas_titulados')"></arrow-link>
        </div>
        <div class="ofertas-list" v-else-if="how == 2">
          <p class="mt-20">Actualmente no hay ofertas de titulados disponibles.</p>
        </div>
      </template>
       
      <template v-if="ofertasEmpleo && !itsLoader">
        <div class="ofertas-list" v-if="ofertasEmpleo.length > 0" v-show="!itsLoader && how == 3">
          <p class="mt-20">Ofertas de empleo dirigidas a personas desempleadas o titulados de la ULE.</p>
          <oferta-el v-for="(oferta, key) in ofertasEmpleo.slice(0,5)" :key="`empleo-${key}`" :data="oferta"
            :type="'empleo'"></oferta-el>
          <div class="contenedor-ver-todas" :style="ownstyles.verTodas"></div>
          <arrow-link class="arrow-link" :text="'Ver todas'" :to="$t('enlaces.ofertas_empleo')"></arrow-link>
        </div>
        <div class="ofertas-list" v-else-if="how == 3">
          <p class="mt-20">Actualmente no hay ofertas de empleo disponibles.</p>
        </div>
      </template>

      

    </template>

  </section>

</template>

<script lang="js">

  import { mapGetters } from 'vuex'

  import ofertaEl from './oferta-el';
  import fakeofertaEl from './oferta-el--fake';

  import arrowLink from '@/components/parts/icons/arrow-link';


  import loadingView from '@/components/parts/loading';

  export default {
    name: 'modulo-ofertas',
    data() {
      return {
        how: 2
      }
    },
  mounted() {
       if (this.isEstudiante && this.isTitulado) {
          this.how = 2;
        }
        else if (this.isEstudiante) {
          this.how = 1;
        }
    },
    computed: {
      ...mapGetters({
        style: 'getStyles',
        ofertasEmpleo: 'getOfertasEmpleo',
        ofertasPracticasTitulados: 'getOfertasPracticasTitulados',
        ofertasPracticasEstudiantes :'getOfertasPracticasEstudiantes',
        candidaturas: 'getCandidaturas',
        colors: 'basicColors',
        params: 'getParamsOfertas',
        programas: 'getProgramasActivos',
        dominios: 'getDominios',
        isTitulado: 'isTitulado',
        isEstudiante: 'isEstudiante'
      }),
      itsLoader: function () {
        // Consideramos que ha terminado de cargar cuando tenemos
        // los parámetros de empleo, prácticas y prácticas titulados.
        const params = this.params || {};
        const empleoLoaded = params.empleo && params.empleo !== '';
        const practicasLoaded = params.practicas && params.practicas !== '';
        const practicasTitLoaded =
          params.practicas_titulados &&
          params.practicas_titulados.numTotal !== null &&
          params.practicas_titulados.numTotal !== undefined;

        // Mientras no tengamos los tres, mostramos loader
        return !(empleoLoaded && practicasLoaded && practicasTitLoaded);
      },
      ownstyles: function () {
        return {
          selectorTipo: {
            'border-top': `4px solid ${(!!this.colors.basicAlternative) ? this.colors.basicAlternative : this.colors.basic}`,
            'background': `${(!!this.colors.basicAlternative) ? this.colors.basicAlternative : this.colors.basic}`,
            'color': (!!this.colors.basicAlternative) ? this.colors.basicAlternative : this.colors.basic
          },
          verTodas: {
            'border-top': `1px solid ${this.colors.soft_black}`
          }
        }
      }
    },
    components: {
      'oferta-el': ofertaEl,
      'oferta-el--fake': fakeofertaEl,
      'arrow-link': arrowLink,
      'loading': loadingView,
    },
    watch: {
      'isEstudiante': function () {
        if (this.isEstudiante && this.isTitulado) {
          this.how = 2;
        }
        else if (this.isEstudiante) {
          this.how = 1;
        }
      },
      
    }
  }
</script>

<style scoped lang="scss">
  .ofertas-home {
    width: 100%;
  }

  .contenedor-ver-todas {
    margin-top: 20px;
    padding-top: 20px;
  }

  .arrow-link {
    /*margin-top: 10px;*/
  }

  .sin-ofertas h2 {
    font-weight: 800;
    width: 100%;
    font-size: 36px;
    margin-bottom: 20px;
  }

  .sin-ofertas p {
    text-align: center;
    display: inline-block;
  }
  .oferta.-programa{
    position: relative;
    padding-top: 10px;
  }

  @media screen and (max-width: 600px) {
    .selector-tipo a {
      border-right: none;
      padding-right: 5px;
      padding-left: 5px;
      width: 50%;
      margin-right: 0;
      font-size: 12px;
      height: 40px;
      line-height: 40px;
      margin-top: 0;
    }

    .selector-tipo a:last-of-type:first-of-type {
      width: 100%;
    }
  }


  @media screen and (max-width: 480px) {

    .selector-tipo a {
      font-size: 16px;

      span.pc {
        display: none;
      }

      span.mvl {
        display: block;
      }
    }


  }
</style>


// WEBPACK FOOTER //
// src/components/views/home/modulo-ofertas.vue